import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { DevHubTabbedPage } from '@devxdiscover/devhub-ui';
import { UsersCloudAccounts } from '../cloudAccounts/UsersCloudAccounts';
import DeviceListPage from '../../DeviceListPage';
import { CnapTenancy } from '../Cnaptenancy';
import { Feature } from '@devxdiscover/devhub-common';
import { ConfigHelper } from '@devxdiscover/devhub-common';
import {
  SnykOnboarding,
  SnykProvider,
  ConstantsProvider,
} from '@devxprotect/plugin-devxprotect-experience';
import { ConnectionsAiTab } from './ConnectionsAiTab';
/**
 * Custom Settings Page Component for DevHub
 * @constructor
 */
export const Connections = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const tabPath = location.pathname.split('/').pop();

  const tabs = [
    {
      label: 'Cloud Accounts',
      route: 'cloud-accounts',
      content: <UsersCloudAccounts />,
    },
    {
      label: 'Device List',
      route: 'device-list',
      content: <DeviceListPage />,
    },
  ];

  if (ConfigHelper?.instance?.isFeatureEnabled(Feature.CNAP_TENANCY)) {
    tabs.push({
      label: 'Cnap Tenancy List',
      route: 'CNAP-list',
      content: <CnapTenancy />,
    });
  }

  // Only add Snyk Onboarding tab if feature is enabled
  if (ConfigHelper?.instance?.isFeatureEnabled(Feature.SNYK_ONBOARDING)) {
    tabs.push({
      label: 'Snyk Onboarding',
      route: 'snyk-onboarding',
      content: (
        <ConstantsProvider>
          <SnykProvider>
            <SnykOnboarding />
          </SnykProvider>
        </ConstantsProvider>
      ),
    });
  }

  if (ConfigHelper?.instance?.isFeatureEnabled(Feature.AI_INVENTORY)) {
    tabs.push({
      label: 'AI Resources',
      route: 'ai',
      content: <ConnectionsAiTab />,
    });
  }

  const getTabIndex = (path: string | undefined) => {
    const tabIndex = tabs.findIndex(tab => tab.route === path);
    return tabIndex >= 0 ? tabIndex : 0;
  };

  const initialTab = getTabIndex(tabPath);
  const [currentTab, setCurrentTab] = useState(initialTab);
  useEffect(() => {
    const newIndex = getTabIndex(tabPath);
    if (newIndex !== currentTab) {
      setCurrentTab(newIndex);
    } else if (!tabPath) {
      navigate(tabs[0].route, { replace: true });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tabPath, navigate, currentTab, tabs]);
  return (
    <DevHubTabbedPage
      title="Connections"
      subtitle="DevHub Connections"
      tabs={tabs}
      navigate={navigate}
      currentTab={currentTab} // Pass the current tab index as a prop
    />
  );
};
